/* eslint-disable arrow-parens */
/* eslint-disable import/first */
/* eslint-disable no-mixed-operators */
/* eslint-disable no-shadow */
import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import moment from 'moment';
import Loader from '../../common/components/Loader';
import { Modal, Form, Input, Switch } from 'antd';
import Portlet from '../../common/components/Portlet';
import PaginatedTable from '../../common/components/Table/PaginatedTable';
import FeaturesWorkflowModal from '../../common/components/Modal/FeaturesWorkflow';
import SpinToWinSection from '../../common/components/SpinToWinSection';
import {
  LOCK_TICKET_SCAN,
  UNLOCK_TICKET_SCAN,
} from '../../redux/constants/features_actions';
import {
  fetchFeaturesAuditTrail,
  saveFeatureAuditTrailComment,
  resetFeaturesAuditTrailPagination,
  startFeaturesWorkflow,
  fetchFeaturesSettings,
  fetchSpinToWinSettings,
  startTicketscanToggleFlow,
  startTicketscanLimitFlow,
} from '../../redux/actions';
import {
  setCommentFocusIntervalRef,
  clearIntervalRef,
} from '../../common/lib/utils';
import './index.css';
import {
  isFeaturesLoadingSelector,
  isTicketscanEnabledSelector,
  ticketscanLimitSelector,
  isTicketscanUnlimitedSelector,
  featuresAuditTrailSelector,
  isFeaturesFetchingAuditTrailSelector,
  featuresAuditTrailTotalCountSelector,
  featuresAuditTrailLimitSelector,
  featuresAuditTrailOffsetSelector,
  ticketscanSelector,
} from '../../redux/selectors/featureActionsSelector';
// TODO: reorganize file.

const mapStateToProps = state => ({
  isAdmin: state.loginReducer.isAdmin,
  auditTrail: featuresAuditTrailSelector(state),
  isFetchingAuditTrail: isFeaturesFetchingAuditTrailSelector(state),
  auditTrailTotalCount: featuresAuditTrailTotalCountSelector(state),
  auditTrailLimit: featuresAuditTrailLimitSelector(state),
  auditTrailOffset: featuresAuditTrailOffsetSelector(state),
  isTicketscanEnabled: isTicketscanEnabledSelector(state),
  ticketscanOptions: ticketscanSelector(state),
  ticketscanLimit: ticketscanLimitSelector(state),
  isTicketscanUnlimited: isTicketscanUnlimitedSelector(state),
  isLoading: isFeaturesLoadingSelector(state),
});
const mapDispatchToProps = {
  fetchFeaturesAuditTrail,
  resetFeaturesAuditTrailPagination,
  fetchFeaturesSettings,
  saveFeatureAuditTrailComment,
  startFeaturesWorkflow,
  fetchSpinToWinSettings,
  startTicketscanToggleFlow,
  startTicketscanLimitFlow,
};

const featuresPortletConfig = {
  title: 'Features',
};

const tablePortletConfig = {
  title: 'Features Audit Trail',
};

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
  currentPage: stateProps.auditTrailOffset / stateProps.auditTrailLimit + 1,
  lockTicketScan: () =>
    dispatchProps.startTicketscanToggleFlow({
      newTicketscanOptions: {
        ...stateProps.ticketscanOptions,
        isEnabled: false,
      },
      toggleType: LOCK_TICKET_SCAN,
    }),
  unlockTicketScan: () =>
    dispatchProps.startTicketscanToggleFlow({
      newTicketscanOptions: {
        ...stateProps.ticketscanOptions,
        isEnabled: true,
      },
      toggleType: UNLOCK_TICKET_SCAN,
    }),
  setTicketScanLimit: () =>
    dispatchProps.startTicketscanLimitFlow({
      newTicketscanOptions: {
        ...stateProps.ticketscanOptions,
      },
    }),
  getPage(page) {
    const { auditTrailLimit } = stateProps;
    const zeroBasedPageNumber = page - 1;
    const auditTrailOffset = zeroBasedPageNumber * stateProps.auditTrailLimit;
    dispatchProps.fetchFeaturesAuditTrail({
      auditTrailLimit,
      auditTrailOffset,
    });
  },
});

const Features = ({
  isAdmin,
  isLoading,
  currentPage,
  getPage,
  auditTrail,
  auditTrailLimit,
  auditTrailOffset,
  auditTrailTotalCount,
  saveFeatureAuditTrailComment,
  fetchFeaturesAuditTrail,
  fetchFeaturesSettings,
  fetchSpinToWinSettings,
  resetFeaturesAuditTrailPagination,
  isFetchingAuditTrail,
  ticketscanOptions,
  isTicketscanEnabled,
  ticketscanLimit,
  isTicketscanUnlimited,
  lockTicketScan,
  unlockTicketScan,
  setTicketScanLimit,
}) => {
  const [isSwitchOn, setIsSwitchOn] = useState(ticketscanOptions.isEnabled);
  const switchTimeoutRef = useRef(null);
  // Reset switch state if modal was cancelled
  useEffect(() => {
    setIsSwitchOn(ticketscanOptions.isEnabled);
  }, [ticketscanOptions]);

  // Cancel timer upon unmount if exists
  useEffect(() => {
    if (switchTimeoutRef.current) {
      clearTimeout(switchTimeoutRef.current);
      switchTimeoutRef.current = null;
    }
  }, []);

  // Visually show switch flipping and then open modal after
  // a short timeout
  const flipSwitch = () => {
    if (!switchTimeoutRef.current) {
      setIsSwitchOn(prevSwitchState => !prevSwitchState);
      switchTimeoutRef.current = setTimeout(() => {
        if (isTicketscanEnabled) {
          lockTicketScan();
        } else {
          unlockTicketScan();
        }
        switchTimeoutRef.current = null;
      }, 100);
    }
  };
  const [visible, setVisible] = useState(false);

  // This effect and refs focuses the comment form field upon displaying it and
  // cleans up interval upon unmount or close modal
  const commentRef = useRef();
  const intervalRef = useRef();
  useEffect(() => {
    if (visible) {
      setCommentFocusIntervalRef(commentRef, intervalRef);
    } else {
      clearIntervalRef(intervalRef);
    }
    return () => clearIntervalRef(intervalRef);
  }, [visible]);

  const [form] = Form.useForm();

  useEffect(() => {
    fetchFeaturesAuditTrail({ auditTrailLimit, auditTrailOffset });
    // reset pagination upon unmount
    return resetFeaturesAuditTrailPagination;
  }, []);

  useEffect(() => {
    fetchFeaturesSettings();
    fetchSpinToWinSettings();
  }, []);

  const showModal = () => {
    setVisible(true);
  };

  const onSubmit = (values) => {
    const comment = _.get(values, 'audit-log-comment');
    saveFeatureAuditTrailComment({
      comment,
      auditTrailLimit,
      auditTrailOffset,
    });
    setVisible(false);
  };

  const handleCancel = () => {
    setVisible(false);
  };

  const columns = [
    {
      title: 'Admin',
      dataIndex: 'admin_user_first_name',
      render: (text, record) =>
        `${record.admin_user_first_name} ${record.admin_user_last_name}`,
    },
    {
      title: 'Time',
      dataIndex: 'created_at',
      render: record => moment(record).format('MM/DD/YY H:mm'),
    },
    {
      title: 'Activity',
      dataIndex: 'activity',
    },
    {
      title: 'Comment',
      dataIndex: 'comment',
      render: (text) => (
        <div
          style={{
            wordWrap: 'break-word',
            wordBreak: 'break-word',
            maxWidth: '500px',
          }}
        >
          {text}
        </div>
      ),
    },
  ];

  return (
    <div className="row">
      <div className="order-1 col-12">
        <FeaturesWorkflowModal />
        <Modal
          title="Please add a comment"
          centered
          visible={visible}
          okText="Submit"
          cancelText="Cancel"
          onOk={form.submit}
          onCancel={handleCancel}
          destroyOnClose
        >
          <Form form={form} onFinish={onSubmit} preserve={false}>
            <Form.Item name="audit-log-comment">
              <Input.TextArea
                className="comment-text-area"
                placeholder="add optional comment here"
                rows={4}
                ref={commentRef}
                maxLength={280}
                autoComplete="off"
              />
            </Form.Item>
          </Form>
        </Modal>
        <Loader isLoading={isLoading}>
          <div className="features-portlet">
            <Portlet config={featuresPortletConfig}>
              <div className="d-flex align-items-center">
                <div className="col-2">
                  <span className="font-weight-bold">Ticket Scan</span>
                </div>
                <div className="col-2">
                  <Switch
                    checked={isSwitchOn}
                    checkedChildren="Unlocked"
                    unCheckedChildren="Locked"
                    disabled={!isAdmin}
                    onClick={flipSwitch}
                  />
                </div>
                <div className="">
                  <button
                    className="bg-transparent btn btn-link text-reset font-weight-bold user-select-none"
                    onClick={setTicketScanLimit}
                    disabled={!isAdmin}
                  >
                    <u className="text-primary">
                      <small>
                        {`Ticket Scan Number Limit: ${
                          isTicketscanUnlimited ? 'Unlimited' : ticketscanLimit
                        }`}
                      </small>
                    </u>
                  </button>
                </div>
              </div>
            </Portlet>
          </div>
          <div className="row">
            <SpinToWinSection />
          </div>
          <div className="position-relative">
            <Portlet config={tablePortletConfig}>
              {isAdmin && (
                <div className="features-audit-trail-comment-btn">
                  <button
                    disabled={!isAdmin}
                    onClick={() => {
                      showModal(true);
                    }}
                    className="btn btn-secondary"
                  >
                    Add Comment
                  </button>
                </div>
              )}
              <PaginatedTable
                columns={columns}
                dataSource={auditTrail}
                rowKey={record => record.id}
                currentPage={currentPage}
                getPage={getPage}
                loading={isFetchingAuditTrail}
                limit={10}
                totalCount={auditTrailTotalCount}
              />
            </Portlet>
          </div>
        </Loader>
      </div>
    </div>
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(Features);



// WEBPACK FOOTER //
// ./src/js/views/features/index.jsx